import React from 'react';
import T from 'i18n-react';
import PropTypes from 'prop-types';
import { formatDate } from '../../utils/loaLawyerHelpers';

const MajorText = (props) => {
  const {
    paxData,
    lawFirm,
    airline,
    country: lawFirmCountry
  } = props;
  const {
    name: lawFirmName,
    street: lawFirmStreet,
    city: lawFirmCity,
  } = lawFirm || {}
  const {name: airlineName} = airline
  const {profession} = paxData

  return (
    <p>
      <b>{T.translate('majorMinorText1', {...paxData, birthDate: formatDate(paxData.birthDate)})}</b>{" "}
      {T.translate('majorMinorText2')}{" "}
      <b>{profession}</b>{" "}
      {T.translate('majorMinorText5')}{" "}
      <b>{lawFirmName}</b>,{" "}
      {T.translate('majorMinorText6')}{" "}
      <b>{lawFirmStreet}, {lawFirmCity}, {lawFirmCountry}</b>,{' '}
      {T.translate('majorMinorText7')}{" "}
      <b>{airlineName}</b>
      {T.translate('majorMinorText8')}{" "}
    </p>
  );
}

MajorText.propTypes = {
  paxData: PropTypes.object.isRequired,
  lawFirm: PropTypes.object.isRequired,
  airline: PropTypes.object.isRequired,
  country: PropTypes.string.isRequired,
};

MajorText.defaultProps = {
  airline: {},
  lawFirm: {},
};

export default MajorText;



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/MajorText.js